import axios from "axios";

export const getSection5 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/landing-page-s5-learn-more?populate[Comment][populate]=*&populate=Video`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
